import { Link } from "react-router-dom";
import { Shield, Wallet, Headphones, ArrowRight } from "lucide-react";
import { AffiliateCtaBox } from "@/components/affiliate/AffiliateCtaBox";
import { AffiliateDisclosure } from "@/components/affiliate/AffiliateDisclosure";

export function HomePartnerStrip() {
  return (
    <section className="py-14 bg-gradient-to-b from-muted/40 via-background to-muted/30 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-end justify-between mb-5 gap-4 flex-wrap">
          <div>
            <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-2 py-0.5 rounded-full mb-2">
              Annonce
            </span>
            <h2 className="font-display text-2xl sm:text-3xl font-bold">Spar tid på det praktiske</h2>
            <p className="text-sm text-muted-foreground mt-1 max-w-xl">
              Vi har samlet vores foretrukne partnere til forsikring, finansiering, ladeboks – og lyd til turen.
            </p>
          </div>
          <Link
            to="/vaerktoejer"
            className="text-sm font-medium text-primary hover:underline inline-flex items-center gap-1"
          >
            Se alle partnere <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <AffiliateDisclosure compact className="mb-5" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <AffiliateCtaBox
            affiliateId="tjenestetorvetForsikring"
            title="Forsikring til din elbil"
            text="Få og sammenlign tilbud fra flere selskaber – på under 2 minutter."
            cta="Få 3 forsikringstilbud"
            microcopy="Gratis og uforpligtende"
            icon={<Shield className="w-5 h-5" />}
            compact
          />
          <AffiliateCtaBox
            affiliateId="leasyMinilaan"
            title="Lån til din elbil"
            text="Beregn månedlig ydelse og se hvad du kan låne til din nye bil."
            cta="Beregn månedlig ydelse"
            microcopy="Svar med det samme"
            icon={<Wallet className="w-5 h-5" />}
            compact
          />
          <AffiliateCtaBox
            affiliateId="mofibo"
            title="Lyd til turen"
            text="Lydbøger og podcasts til pendlerturen og bilferien."
            cta="Prøv Mofibo gratis"
            microcopy="30 dages gratis prøve"
            icon={<Headphones className="w-5 h-5" />}
            compact
          />
        </div>
      </div>
    </section>
  );
}
